import ResponsiveDialog from "../ResponsiveDialog";
// import AuthRightSideDesign from "./auth-right-side-design";
import AuthRightSideDesign from "../LoginModal/auth-right-side-design";
// import LoginForm from "./login-form";
import { MoveRight } from "lucide-react";
import { useState } from "react";
import Button from "../Button";
import { Input } from "../Input";
import Label from "../Label";
import PasswordInput from "../PasswordInput";
import PasswordValidationMessage from "../PasswordValidation";


export type LoginModalProps = {
    updateUserDetail: (event: any) => void;
    handleChangeName: (event: any) => void;
    handleChangeLoginPassword: (event: any) => void;
    isUpdating: boolean;
    name: string;
    password: string;
    collabMode: boolean;
    imageGraphicItem: any;
    itemDetails: GetItemDetailsProps;
    logoSrc: string;
    isEightChar: boolean;
    isNumAndCap: boolean;
    isSpecialChar: boolean;
    container?: HTMLElement | ShadowRoot | null;
};
export interface GetItemDetailsProps {
    id: string;
    user_id: string;
    site_order: string | null;
    name: string;
    type: string;
    favicon: string | null;
    image: string | null | any;
    status: string;
    url_host: string;
    url_host_path: string;
    is_active: boolean;
    is_public: boolean;
    invite_token: string;
    iframe_url: string;
    project_id: string | null;
    src: string | null;
    website_care_url: string | null;
    website_design_hub_url: string | null;
    website_care_urls: string | null;
    godaddy_user_id: string | null;
    godaddy_username: string | null;
    workspace_id: number;
    users: {
        label: string;
        value: string;
        checked: boolean;
        avatar: string | null;
        email: string;
        responsible: boolean;
        role: string;
    }[];
    setting: {
        id: number;
        created_at: string;
        updated_at: string;
        user_id: number;
        enabled_wpfeedback: number;
        chrome_extension: number;
        wpf_show_front_stikers: number;
        wpf_allow_backend_commenting: number;
        wpfeedback_font_awesome_script: number;
        delete_data_wpfeedback: number;
        wpfeedback_logo: string;
        is_notification_muted: number;
        wpfeedback_favicon: string;
        wpfeedback_color: string;
        wpf_tutorial_video: string | null;
        wpf_minify_image: number;
        wpfeedback_powered_by: number;
        wpf_powered_link: string | null;
        email_wizard_setup_complete: number;
        wpf_from_email: string | null;
        wpf_from_email_mode: number;
        wpfeedback_more_emails: string | null;
        wpf_every_new_task: number;
        wpf_every_new_comment: number;
        wpf_every_new_complete: number;
        wpf_every_status_change: number;
        wpf_daily_report: number;
        wpf_weekly_report: number;
        wpf_auto_daily_report: number;
        wpf_auto_weekly_report: number;
        wpf_enabled_compact_mode: number;
        wpf_integrations: boolean;
        enabled_2fa: number;
        workspace_id: number;
        status: number;
        permissions: Record<
            string,
            { key: 'client' | 'webmaster' | 'others' | 'guest'; value: boolean }[]
        >;
        notifications: {
            key: string;
            value: boolean;
            label: string;
        }[];
        whitelabel: {
            atarim_color: string;
            logo: string;
            favicon: string;
            logo_link: string | null;
            tutorial_video: string | null;
            mention_atarim: boolean;
        };
        enabled_global_settings: boolean;
        enabled_collaboration: boolean;
        site_name: string;
        project: string | null;
        site_id: string;
        global_settings: boolean;
    };
    milestone: string | null;
    is_whitelabel: boolean;
    total_tasks: number;
    guest_user_id: string;
    account_id: number;
    subscription_status: boolean;
    is_url_valid: boolean;
    role: string;
    proxy_old: boolean;
}

export default function UpdateUserName({
    updateUserDetail,
    handleChangeName,
    handleChangeLoginPassword,
    isUpdating,
    name,
    password,
    itemDetails,
    collabMode,
    imageGraphicItem,
    logoSrc,
    isEightChar,
    isNumAndCap,
    isSpecialChar,
    container
}: LoginModalProps) {

    const [inputSelected, setInputSelected] = useState(false);
    const handleInputFocus = () => {
        setInputSelected(true);
    };


    return (
        <ResponsiveDialog.Content className="text-textcolor isolate max-w-[768px] m-auto my-0 max-w-[950px] border-none p-0 bg-transparent z-[99999]"
            onInteractOutside={(event: { preventDefault: () => any; }) => event.preventDefault()}
            container={container}
        >
            <div className="">
                <div className="max-w-[950px] mx-auto shadow-lg overflow-hidden rounded-2xl bg-gradient-purple">
                    <div className="flex">
                        <div className="bg-background w-[46%] p-[30px_14px] m-3 rounded-lg">
                            <div className="text-center bg-background m-4">
                                <div className='p-0' >
                                    <div className="text-primary flex flex-col items-center pt-8 gap-2">
                                        <img
                                            src={logoSrc}
                                            className="mb-3 inline-flex max-w-[120px]"
                                            alt="Logo"
                                        />
                                        <div className="text-textcolor text-2xl font-bold">
                                            Set Name & Password
                                        </div>
                                        <div className='font-base flex justify-center self-center text-balance text-base text-[#71717a]'>
                                            Fill in your details below
                                        </div>
                                    </div>
                                </div>
                                <form
                                    className="flex w-full flex-col gap-4 mt-4"
                                    onSubmit={updateUserDetail}
                                >

                                    <Label htmlFor="email" className="flex flex-col gap-2 items-start w-full">
                                        Full Name{' '}
                                        <Input
                                            value={name}
                                            placeholder="Full Name*"
                                            type="text"
                                            id="name"
                                            name="name"
                                            autoComplete="email"
                                            onChange={handleChangeName}
                                        ></Input>
                                    </Label>
                                    <Label
                                        htmlFor="password"
                                        className="flex flex-col gap-2 items-start w-full">
                                        Password
                                        <PasswordInput
                                            placeholder="Password*"
                                            onChange={handleChangeLoginPassword}
                                            required
                                            value={password}
                                            id="password"
                                            className="w-full grow"
                                            name="password"
                                            onFocus={handleInputFocus}
                                        />
                                    </Label>
                                    {
                                        inputSelected &&
                                        <PasswordValidationMessage
                                            isEightChar={isEightChar}
                                            isNumAndCap={isNumAndCap}
                                            isSpecialChar={isSpecialChar}
                                        />
                                    }

                                    <div>
                                        <Button
                                            type="submit"
                                            loading={isUpdating}
                                            size="sm"
                                            className="mb-4 w-full text-sm"
                                            rightIcon={<MoveRight size={18} />}
                                            disabled={!name || !password}
                                        >
                                            Submit Details
                                        </Button>

                                    </div>
                                </form>
                            </div>
                        </div>
                        <AuthRightSideDesign
                            projectScreenshot={itemDetails.image}
                            projectUrl={itemDetails.url_host}
                            collabMode={collabMode}
                            imageGraphicItem={imageGraphicItem}
                            itemType={itemDetails.type}
                            itemDetails={itemDetails}
                        />
                    </div>
                </div>
            </div>
        </ResponsiveDialog.Content>
    );
}